
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gsn6zcf6tlmyJGb7k5_45rc9x_fNaO_fyDgJ_45Hiic6ZdLEMeta } from "/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexRUcw0z1vdt4SJMEld_OgkSF5k_gB07vohpuRG23oM_gMeta } from "/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search9Ip_9tOp87sZOjgvl8cOrP7ZpjMjDFig0Zqk5g_VQmcMeta } from "/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index_Syxsgo41g1Iqf0WOyVprSydTkvh74RzU21hzpowONwMeta } from "/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93sx4CL8fEQqyLn8uQdLW497D6rVnb_45QPkg0fQWndvC1QMeta } from "/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexAUd0wck5q05bGbSZCmikxLT3apran1wWm0OI531z3FEMeta } from "/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93qUxVmyL8mV6VVmjQ8hRyPZ9yO8rxlZD06vQZ_45kiDA1QMeta } from "/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexx7VQyI4aYv_PV4XgjLA0Vuf4lLQHTmx17MxsnY4cYucMeta } from "/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_932xSYxRiev_wjYhU6sEpTKADCGMXkxdwIyP2JPs49vW8Meta } from "/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexmr48AeRe_WISONHR2D2GI5CXLd_45rMjssd91NdD5bqkEMeta } from "/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexAlKSiO0xFoKlToI5eWyAC9g8fOfdmuSPUGk8XJcLzWIMeta } from "/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexAUd0wck5q05bGbSZCmikxLT3apran1wWm0OI531z3FEMeta || {},
    component: () => import("/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexx7VQyI4aYv_PV4XgjLA0Vuf4lLQHTmx17MxsnY4cYucMeta || {},
    component: () => import("/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexmr48AeRe_WISONHR2D2GI5CXLd_45rMjssd91NdD5bqkEMeta || {},
    component: () => import("/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexAlKSiO0xFoKlToI5eWyAC9g8fOfdmuSPUGk8XJcLzWIMeta || {},
    component: () => import("/codebuild/output/src1477569306/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]